import type { JSX } from 'react'

export const SentEmptyStateIllustration = (): JSX.Element => {
  return (
    <svg
      width="335"
      height="300"
      viewBox="0 0 335 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M8.7998 157.839C8.79996 215.945 50.7097 263.152 102.527 263.152C102.803 263.152 103.027 262.928 103.027 262.652C103.027 262.376 102.803 262.152 102.527 262.152C51.3689 262.152 9.79996 215.506 9.7998 157.839C9.79996 100.151 45.7513 53.526 102.527 53.5259L206.99 53.5259L190.855 71.4976C190.671 71.703 190.688 72.0192 190.894 72.2036C191.099 72.388 191.415 72.3706 191.6 72.1655L208.434 53.4155C208.604 53.2257 208.604 52.9385 208.434 52.7485L191.601 33.9439C191.416 33.7381 191.1 33.7206 190.895 33.9048C190.689 34.089 190.672 34.4043 190.855 34.6099L206.894 52.5259L102.527 52.5259C45.0551 52.526 8.79996 99.7547 8.7998 157.839Z"
        fill="var(--color-illustration-border)"
      />
      <rect
        x="230.52"
        y="28.5"
        width="89"
        height="52"
        rx="4.5"
        fill="var(--color-illustration-card)"
      />
      <rect
        x="230.52"
        y="28.5"
        width="89"
        height="52"
        rx="4.5"
        stroke="var(--color-illustration-border)"
      />
      <rect
        x="239.02"
        y="72"
        width="7.22222"
        height="5.60623"
        rx="2.80311"
        transform="rotate(-90 239.02 72)"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="249.585"
        y="72"
        width="13.3333"
        height="5.60623"
        rx="2.80311"
        transform="rotate(-90 249.585 72)"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="260.15"
        y="72"
        width="29.4444"
        height="5.60623"
        rx="2.80312"
        transform="rotate(-90 260.15 72)"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="270.717"
        y="72"
        width="20.5556"
        height="5.60623"
        rx="2.80312"
        transform="rotate(-90 270.717 72)"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="281.282"
        y="72"
        width="35"
        height="5.60623"
        rx="2.80312"
        transform="rotate(-90 281.282 72)"
        fill="var(--color-illustration-accent)"
        fillOpacity="0.4"
      />
      <rect
        x="291.848"
        y="72"
        width="20.5556"
        height="5.60623"
        rx="2.80312"
        transform="rotate(-90 291.848 72)"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="302.413"
        y="72"
        width="20.5556"
        height="5.60623"
        rx="2.80312"
        transform="rotate(-90 302.413 72)"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="56.5195"
        y="229.5"
        width="89"
        height="41"
        rx="4.5"
        fill="var(--color-illustration-card)"
      />
      <rect
        x="56.5195"
        y="229.5"
        width="89"
        height="41"
        rx="4.5"
        stroke="var(--color-illustration-border)"
      />
      <path
        d="M141.02 267H64.2484H60.0195V261.583C61.4292 259.856 70.9714 255.334 79.5376 254.753C89.9472 254.047 100.682 250.985 111.417 241.329C121.12 232.601 135.273 233.949 141.02 234.263V267Z"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="262.52"
        y="213.5"
        width="64"
        height="58"
        rx="4.5"
        fill="var(--color-illustration-card)"
      />
      <rect
        x="262.52"
        y="213.5"
        width="64"
        height="58"
        rx="4.5"
        stroke="var(--color-illustration-border)"
      />
      <path
        d="M309.672 222.025L304.742 229.913C304.427 230.416 304.789 231.068 305.382 231.068H315.242C315.835 231.068 316.197 230.416 315.882 229.913L310.952 222.025C310.657 221.551 309.967 221.551 309.672 222.025Z"
        fill="var(--color-illustration-accent)"
        fillOpacity="0.4"
      />
      <path
        d="M310.952 265.042L315.882 257.154C316.197 256.651 315.835 255.999 315.242 255.999L305.382 255.999C304.789 255.999 304.427 256.651 304.742 257.154L309.672 265.042C309.967 265.515 310.657 265.515 310.952 265.042Z"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="272.02"
        y="224"
        width="25"
        height="5"
        rx="1.5"
        fill="var(--color-illustration-element)"
      />
      <path
        d="M309.672 238.025L304.742 245.913C304.427 246.416 304.789 247.068 305.382 247.068H315.242C315.835 247.068 316.197 246.416 315.882 245.913L310.952 238.025C310.657 237.551 309.967 237.551 309.672 238.025Z"
        fill="var(--color-illustration-accent)"
        fillOpacity="0.4"
      />
      <rect
        x="272.02"
        y="240"
        width="25"
        height="5"
        rx="1.5"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="272.02"
        y="256"
        width="25"
        height="5"
        rx="1.5"
        fill="var(--color-illustration-element)"
      />
      <g filter="url(#filter0_d_693_25979)">
        <rect
          x="56.0195"
          y="94"
          width="240"
          height="106"
          rx="5"
          fill="var(--color-illustration-card)"
          shapeRendering="crispEdges"
        />
        <rect
          x="56.5195"
          y="94.5"
          width="239"
          height="105"
          rx="4.5"
          stroke="var(--color-illustration-border)"
          shapeRendering="crispEdges"
        />
        <rect
          x="74.0195"
          y="113"
          width="107"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="74.0195"
          y="127"
          width="125"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="74.0195"
          y="142"
          width="125"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="214.02"
          y="104"
          width="73"
          height="58"
          rx="5"
          fill="var(--color-illustration-secondary-element)"
        />
        <rect
          x="88.0195"
          y="179"
          width="25"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="173.02"
          y="179"
          width="25"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="258.02"
          y="179"
          width="25"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <path
          d="M158.365 187.527C159.771 188.248 161.388 188.443 162.925 188.078C164.462 187.712 165.818 186.809 166.748 185.533C167.679 184.256 168.122 182.688 167.999 181.113C167.877 179.538 167.195 178.059 166.078 176.942C164.961 175.824 163.481 175.143 161.906 175.02C160.331 174.897 158.764 175.341 157.487 176.271C156.21 177.202 155.308 178.558 154.942 180.095C154.576 181.632 154.771 183.249 155.493 184.654L154.02 189L158.365 187.527Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M252.725 176.453C253.323 177.057 253.323 178.037 252.725 178.641L245.762 185.673L242.636 182.515L239.634 185.547C239.036 186.151 238.066 186.151 237.468 185.547C236.87 184.943 236.87 183.963 237.468 183.359L242.636 178.139L245.762 181.297L250.558 176.453C251.157 175.849 252.127 175.849 252.725 176.453Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.5592 187.752C76.2107 188.083 75.695 188.083 75.3465 187.752L74.9475 187.373C71.3769 183.977 69.0195 181.736 69.0195 178.995C69.0195 176.754 70.6939 175 72.8329 175C74.0393 175 75.1971 175.588 75.9529 176.514C76.7086 175.588 77.8665 175 79.0729 175C81.2118 175 82.8862 176.754 82.8862 178.995C82.8862 181.736 80.5289 183.977 76.9582 187.373L76.5592 187.752Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_693_25979"
          x="56.0195"
          y="94"
          width="240"
          height="107.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_693_25979"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_693_25979"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
